<template>
  <div class="wrapper">
    <div class="header">
      <div class="main">
        <p>全溯应用市场</p>
        <div class="search">
          <van-icon name="arrow-left" class="icon" @click="goBack" />
          <van-search 
            v-model="value"
            left-icon
            shape="round"
            :placeholder="placeholder"
            :clearable="false"
            @search="search"
          >
            <template #right-icon>
              <div class="button" @click="search">搜索</div>
            </template>
          </van-search>
          <div class="area">
            <img src="@/assets/imgs/dingwei.png">
            <span>芜湖</span>
          </div>
        </div>
      </div>
    </div>
    <div class="fill"></div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '搜索门诊/疫苗/疾病关键词'
    }
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    search() {
      // if (!this.value.trim()) return
      this.$emit('search', this.value.trim())
    },
    goBack() {
      this.$router.go(-1)
    },
    setValue(value) {
      this.value = value
    },
    clear() {
      this.value = ''
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  .header {
    width: 100%;
    height: 97px;
    background: url(../../assets/imgs/top-bj.png) no-repeat center/100% 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    box-sizing: border-box;
    padding: 5px 13px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .main {
      p {
        font-size: 17px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 15px;
      }
      .search {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icon {
          color: #fff;
        }
        .area {
          display: flex;
          align-items: center;
          img {
            width: 13px;
            height: 17px;
            margin-right: 8px;
          }
          span {
            color: #fff;
          }
        }
      }
    }
  }
  .fill {
    height: 97px;
  }
}
.button {
  width: 45px;
  height: 24px;
  border-radius: 12px;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  background: var(--blue);
  transform: scale(1.15);
}
.van-search {
  padding: 0;
  border-radius: 17px;
}
</style>